import {clsx} from 'clsx'
import {Hero, type HeroProps} from '../../generic/Hero/Hero'

import Styles from './HeroSection.module.css'

export type HeroSectionProps = HeroProps & {
  shouldHideSpacer?: boolean
  hasBottomBorder?: boolean
}

export type HeroSectionPropsData = Omit<HeroSectionProps, 'shouldHideSpacer' | 'hasBottomBorder'>

export const defaultProps: Partial<HeroSectionProps> = {}

export const HeroSection = (props: HeroSectionProps) => {
  const initializedProps: HeroSectionProps = {...defaultProps, ...props}
  const {shouldHideSpacer, hasBottomBorder, ...heroProps} = initializedProps

  return (
    <div className={clsx(Styles['HeroSection'], hasBottomBorder && Styles['HeroSection--hasBottomBorder'])}>
      <Hero {...heroProps} />
      {!shouldHideSpacer && (
        <div className={clsx(Styles['HeroSection__Spacer'], hasBottomBorder && Styles['HeroSection__Spacer--short'])} />
      )}
    </div>
  )
}
